var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingContainer"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"loadingOverlay"},[_c('div',{staticClass:"spinner"},[_c('SpinnerIcon')],1)]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }